export const PERMS = {
    READ: 'transport_conditions.read',
    UPDATE: 'transport_conditions.update',
    DELETE: 'transport_conditions.delete',
    CREATE: 'transport_conditions.create',
    EXPORT: 'transport_conditions.export',
}
